/**
 * Transaction Repository Factory
 *
 * 환경 변수(USE_MOCK_DATA)에 따라 Mock 또는 GoogleSheets Repository를 반환합니다.
 */

import { env } from '@/core/config/env'
import { logger } from '@/core/logger'
import { MockTransactionRepository } from './MockTransactionRepository'
import { GoogleSheetsTransactionRepository } from './GoogleSheetsTransactionRepository'
import type { TransactionRepository } from './TransactionRepository'

/**
 * Transaction Repository 인스턴스 생성
 *
 * env.USE_MOCK_DATA 값에 따라 자동으로 선택됩니다.
 *
 * @returns TransactionRepository 구현체
 */
export function createTransactionRepository(): TransactionRepository {
  if (env.USE_MOCK_DATA) {
    logger.info('🔧 Mock Transaction Repository 사용')
    return new MockTransactionRepository()
  }

  logger.info('🔗 Google Sheets Transaction Repository 사용')
  return new GoogleSheetsTransactionRepository()
}

/**
 * 전역 Transaction Repository 인스턴스
 *
 * 애플리케이션 전체에서 동일한 인스턴스를 사용합니다.
 */
export const transactionRepository = createTransactionRepository()

// Re-export 타입
export type { TransactionRepository } from './TransactionRepository'
export type { Transaction, TransactionInput, TransactionFilter } from '../types/Transaction'
